<template>
      <div>
        <div class="Table-Info">
            <Tables  ref="tableNovaUnidade"
            style="font-family:'Segoe UI'"
            :columns="columns"
             v-on:Load="Onload"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="true"

            >
            <tr v-for="data in ArrayEmpreendimentos" :key="data.id">
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.nomeEmpreendimento"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.apelido"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :newState="true" :colorStatus="data.status == 0 ? '#0e6b1a' : '#bf0606'" :descriptionNewStatus="data.status == 0 ? 'ATIVO' : 'INATIVO'"></TableColumn>
              <TableColumn v-on:Edit="$emit('Details', data)"  :IsText="true" :value="data.dataAcaoFormatada"></TableColumn>
                <TableColumn
                  :IsActiveButton="data.status == 0 ? true : false"
                  :newEditGama="true"
                  :newActiveGama="data.status == 1 ? true : false"
                  v-on:Active="openModalActive(data)"
                  v-on:Delete="openModalDelete(data)"
                  v-on:Edit="openModalEdit(data)"
                />
              </tr>
              <template #ButtonsAprova>
                  <div>
                    <button @click="openModalInsert(1)"  class="btn-head"><i class="fas fa-plus"></i></button>
                  </div>
              </template>
          </Tables>
        </div>

        <b-modal
          hide-footer
          size="md"
          centered
          ref="add-travel-modal-empreendimento"
          id="add-travel-modal-empreendimento"
          :title="FlagCriacao != 1 ? 'EDITAR EMPREENDIMENTO' : 'CADASTRAR EMPREENDIMENTO'"
        >
        <template #modal-title>
          <div class="header-title">{{FlagCriacao != 1 ? 'EDITAR EMPREENDIMENTO' : 'CADASTRAR EMPREENDIMENTO'}}</div>
        </template>
        <div v-if="FlagCriacao != 1">
          <div class="empreedimento">
            <div>
              <div class="">Empreendimento: {{nomeEmpreedimento}}</div>
            </div>
          </div>

          <div class="apelido">
            <div>
              <div class="titulo-modal-novo-tecnico">Apelido*</div>
              <div class="input-modal-novo-tecnico">
                <input class="input-pesquisar form-control" placeholder="Digite o nome do apelido para o empreendimento" v-model="apelido">
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="apelido">
            <div>
              <div class="titulo-modal-novo-tecnico">Nome*</div>
              <div class="input-modal-novo-tecnico">
                <input class="input-pesquisar form-control" placeholder="Digite o nome para o empreendimento" v-model="nome">
              </div>
            </div>
          </div>
          <div class="apelido">
            <div>
              <div class="titulo-modal-novo-tecnico">Apelido</div>
              <div class="input-modal-novo-tecnico">
                <input class="input-pesquisar form-control" placeholder="Digite o nome do apelido para o empreendimento" v-model="apelido">
              </div>
            </div>
          </div>
        </div>
          <div class="button">
            <div class="d-flex m-3">
              <button @click="back" class="button-cancel mr-2">
                Cancelar
              </button>
              <button @click="verificafluxo()" :disabled="this.desabilitar" class="button-save ml-2">ADICIONAR</button>
            </div>
          </div>
        </b-modal>
      </div>
</template>

<script>
import ChangingNameTable from './ChangingNameTable'
export default ChangingNameTable
</script>

<style scoped>
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.btn-head{
  background-color: #008148;
  color: white;
  border: none;
  width: 3rem;
  font-weight: bold;
  height: 2rem;
  font-size: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}
.apelido{
  margin-top: 1rem;
  width: 100%;
}
.empreedimento{
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  background: #e1e1e1;
  border-radius: 10px;
  width: 100%;
}
.button-cancel, .button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 225px;
  height: 40px;
  font: bold 14px 'Segoe UI';
}

.button-save {
  background-color: #008148;
  color: white;
  font-family: 'Segoe UI';
  font-size: 14px;
}
.button{
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 5px;
}

.input-modal-novo-tecnico{
  width: 100%;
}

.nome-telefone-container{
  display: flex;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
}

#body-details{
    height: 60vh;
}
#head-details{
  display: flex;
  justify-content: space-between;
}

.ativo {
  color: green;
}

.inativo {
  color: red;
}
.text-center.PositionBottom {
    padding-top: 20px;
}

.card-bottom-radius-8 {
    width: fit-content;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ChangingNameBusiness/components/ChangingNameTable.vue